import * as React from 'react';

import { dollarFormatter } from 'af-utils/format.util';

import { SegmentLabel } from '@acceligentllc/storybook';

import LockedValue from 'af-components/LockedValue';

import { previewSectionClass, previewSectionClassColumn2, previewSectionClassRow } from '../../helpers';

type Props = {
	salesId: Nullable<string>;
	salesLeadName: Nullable<string>;
	estimateTotal: Nullable<number>;
};

const SalesSection: React.FC<Props> = ({ estimateTotal, salesId, salesLeadName }) => {

	const estimateTotalFormatted = estimateTotal !== null ? dollarFormatter.format(estimateTotal) : null;
	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Sales"
				tooltip="Overview of the sales record associated with this entry, including identification, assigned lead, and estimated value."
			/>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn2}>
					<LockedValue label="Sales ID" value={salesId} />
				</div>
				<div className={previewSectionClassColumn2}>
					<LockedValue label="Sales Lead" value={salesLeadName} />
				</div>
				<div className={previewSectionClassColumn2}>
					<LockedValue label="Estimate total" value={estimateTotalFormatted} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(SalesSection);
